import { createContext, useContext } from 'react'

import type { MonitoringChannel } from '@oneToOne/shared/ws/monitoring'

import { useLiveHelperScreenRecorder } from './useLiveHelperScreenRecorder'
import { useMonitoringChannel } from './useMonitoringChannel'
import { useMonitoringCrossTabCommunication } from './useMonitoringCrossTabCommunication'
import { useSetMonitoringActions } from './useSetMonitoringActions'

const MonitoringChannelContext = createContext<MonitoringChannel | undefined>(
  undefined,
)

/** @returns The monitoring channel instance provided by the context. */
export function useMonitoringChannelContext(): MonitoringChannel | undefined {
  return useContext(MonitoringChannelContext)
}

/** Monitoring channel instance context provider. */
export const MonitoringChannelProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const channel = useMonitoringChannel()
  useLiveHelperScreenRecorder(channel)
  useMonitoringCrossTabCommunication()
  useSetMonitoringActions()

  return (
    <MonitoringChannelContext.Provider value={channel}>
      {children}
    </MonitoringChannelContext.Provider>
  )
}
